import { PostalCodePipe } from "@cms/shared-library"

export function formatAddress(x: any, hideCity: boolean = false, hideCountry: boolean = false) {
  if (x == null || isNullOrEmpty(x.AddressLine??x.Address)) return 'N/A'
  let stringAddress = ''
  let hasCityPrefix = !hideCity && !isNullOrEmpty(x.CityTown??x.City) ? ", " : ''

  if (!isNullOrEmpty(x.AptSuiteUnit)) stringAddress += x.AptSuiteUnit + ' - '
  stringAddress += (x.AddressLine??x.Address) + hasCityPrefix
  // if (!isNullOrEmpty(x.PoBox)) stringAddress += " " + x.PoBox + hasCityPrefix
   stringAddress += "<br/>"

  if (!hideCity && !isNullOrEmpty(x.CityTown??x.City)) stringAddress += (x.CityTown??x.City) + ", "
  if (!isNullOrEmpty(x.Province)) stringAddress += x.Province
  if (!isNullOrEmpty(x.PostalCode)) {
    var cleaned = x.PostalCode.toUpperCase().replace(/\s/g, '');
    var match = cleaned.match(/([ABCEGHJKLMNPRSTVWXYZ]\d){3}/);
    if (match && cleaned.length == 6)
      stringAddress += (isNullOrEmpty(x.Province) ? '' : ', ') + cleaned.substring(0, 3) + ' ' + cleaned.substring(3);
    else
      stringAddress += (isNullOrEmpty(x.Province) ? '' : ', ') + cleaned;
  }
  if (!hideCountry && !isNullOrEmpty(x.Country)) 
  {
    stringAddress += "<br/>"
    stringAddress += x.Country;
  }
  if (!isNullOrEmpty(x.PoBox)) {
    stringAddress += "<br/>"
    stringAddress += "PO Box " + x.PoBox
  }  
  return stringAddress == '' ? 'N/A' : stringAddress.trim()
}

export function formatAddressForLearner(x: any, hideCity: boolean = false, hideCountry: boolean = false) {
  if (x == null || isNullOrEmpty(x.AddressLine??x.Address)) return 'N/A'
  let stringAddress = ''
  let hasCityPrefix = !hideCity && !isNullOrEmpty(x.CityTown??x.City) ? " " : ''

  if (!isNullOrEmpty(x.AptSuiteUnit)) stringAddress += x.AptSuiteUnit + ' - '
  stringAddress += (x.AddressLine??x.Address) + hasCityPrefix
  // if (!isNullOrEmpty(x.PoBox)) stringAddress += " " + x.PoBox + hasCityPrefix
   stringAddress += "<br/>"

  if (!hideCity && !isNullOrEmpty(x.CityTown??x.City)) stringAddress += (x.CityTown??x.City) + ", "
  if (!isNullOrEmpty(x.Province)) stringAddress += x.Province
  if (!isNullOrEmpty(x.PostalCode)) {
    var cleaned = x.PostalCode.toUpperCase().replace(/\s/g, '');
    var match = cleaned.match(/([ABCEGHJKLMNPRSTVWXYZ]\d){3}/);
    if (match && cleaned.length == 6)
      stringAddress += (isNullOrEmpty(x.Province) ? '' : ', ') + cleaned.substring(0, 3) + ' ' + cleaned.substring(3);
    else
      stringAddress += (isNullOrEmpty(x.Province) ? '' : ', ') + cleaned;
  }
  if (!hideCountry && !isNullOrEmpty(x.Country)) 
  {
    stringAddress += "<br/>"
    stringAddress += x.Country;
  }
  return stringAddress == '' ? 'N/A' : stringAddress.trim()
}

export function formatAddressMobile(x: any, hideCity: boolean = false, hideCountry: boolean = false) {
  if (x == null || isNullOrEmpty(x.AddressLine??x.Address)) return 'N/A'
  let stringAddress = ''

  if (!isNullOrEmpty(x.AptSuiteUnit)) stringAddress += '<div>' + x.AptSuiteUnit + '</div>'
  stringAddress += '<div>' + (x.AddressLine??x.Address) + '</div>'

  if (!hideCity && !isNullOrEmpty(x.CityTown??x.City)) stringAddress += '<div>' + (x.CityTown??x.City) + ", "
  if (!isNullOrEmpty(x.Province)) stringAddress += x.Province
  if (!isNullOrEmpty(x.PostalCode)) {
    var cleaned = x.PostalCode.toUpperCase().replace(/\s/g, '');
    var match = cleaned.match(/([ABCEGHJKLMNPRSTVWXYZ]\d){3}/);
    if (match && cleaned.length == 6)
      stringAddress += (isNullOrEmpty(x.Province) ? '' : ', ') + cleaned.substring(0, 3) + ' ' + cleaned.substring(3);
    else
      stringAddress += (isNullOrEmpty(x.Province) ? '' : ', ') + cleaned;
  }
  if (!hideCountry && !isNullOrEmpty(x.Country)) stringAddress += "</div><div>" + x.Country + '</div>'
  
 if (!isNullOrEmpty(x.PoBox)) {
  stringAddress += '<div>'
  stringAddress += "PO Box " + x.PoBox + '</div>'
 }
  
 return stringAddress == '' ? 'N/A' : stringAddress.trim()
}

export function isNullOrEmpty(value: string | number) {
  return value == null || value == undefined || value == 0;
}
